module.exports = __webpack_public_path__ + "static/spined_devil-ccef16e85c0cd3af84c93175cefdc4e3.jpg";